













import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import { ListingStatus, ListingCategory } from 'client-website-ts-library/types';
import { View } from 'client-website-ts-library/plugins';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class PropertiesSold extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  handleFilter(filter: ListingFilter) {
    this.listingFilter = new ListingFilter({
      Statuses: [
        ListingStatus.Sold,
      ],
      Categories: [
        ListingCategory.ResidentialSale,
        ListingCategory.ResidentialLand,
        ListingCategory.Rural,
      ],
      PageSize: 9,
      OrderByStatements: [
        ListingOrderBy.SoldDateDesc,
      ],
    });

    this.listingFilter = filter;
  }
}
